import { OpenInNew } from '@mui/icons-material';
import {
  Box,
  Card,
  CardContent,
  Chip,
  IconButton,
  Typography
} from '@mui/material';
import React from 'react';

export default function CompactBreakdownCard({
  title,
  items,
  _color = 'primary',
  onNavigate
}) {
  return (
    <Card
      sx={{
        height: '100%',
        backgroundColor: 'background.paper',
        minHeight: '140px',
        position: 'relative'
      }}
    >
      <CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 } }}>
        <IconButton
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: 'text.secondary',
            '&:hover': {
              color: 'primary.main'
            }
          }}
          size="small"
          onClick={onNavigate}
        >
          <OpenInNew fontSize="small" />
        </IconButton>
        <Typography
          variant="body2"
          color="textSecondary"
          gutterBottom
          sx={{ fontSize: '0.8rem', mb: 1.5, pr: 4 }}
        >
          {title}
        </Typography>
        <Box display="flex" flexDirection="column" gap={0.8}>
          {items.map((item, index) => (
            <Chip
              key={index}
              label={item.label}
              color={item.color}
              size="small"
              sx={{ fontSize: '0.7rem', height: '24px' }}
            />
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}
